/* Ellie Grace Jewellery — interactions (Dawn-safe, namespaced) */
(function () {
  if (window.__egInit) return;   // guard: run once even if loaded by several sections
  window.__egInit = true;

  function init() {
    // Year (footer)
    var yr = document.getElementById('eg-yr');
    if (yr) yr.textContent = new Date().getFullYear();

    // Sticky header shadow on scroll
    var header = document.getElementById('eg-header');
    if (header) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('eg-scrolled', window.scrollY > 20);
      });
    }

    // Mobile nav
    var toggle = document.getElementById('eg-navToggle');
    var links = document.getElementById('eg-navLinks');
    if (toggle && links) {
      toggle.addEventListener('click', function () { links.classList.toggle('eg-open'); });
      links.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { links.classList.remove('eg-open'); });
      });
    }

    // Reveal-on-scroll
    var reveals = document.querySelectorAll('.eg-reveal, .eg-section-head, .eg-collection-card, .eg-product, .eg-testi-grid figure, .eg-split-image, .eg-split-copy, .eg-story-img, .eg-story-copy, .eg-message-text, .eg-message-image');
    reveals.forEach(function (el) { el.classList.add('eg-reveal'); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('eg-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('eg-in'); });
    }

    // Cart counter delight (visual only)
    var counter = document.querySelector('.eg-cart-count');
    var count = counter ? parseInt(counter.textContent, 10) || 0 : 0;
    document.querySelectorAll('.eg-quick, [data-eg-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.tagName === 'A') return;
        e.preventDefault();
        count++;
        if (counter) {
          counter.textContent = count;
          counter.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(1.5)', color: '#B3010C' }, { transform: 'scale(1)' }],
            { duration: 450, easing: 'cubic-bezier(.22,.61,.36,1)' }
          );
        }
        var toast = document.createElement('div');
        toast.textContent = '\u2661 added with love';
        Object.assign(toast.style, {
          position: 'fixed', bottom: '32px', right: '32px',
          background: '#2E2E2E', color: '#FBF7F0', padding: '14px 22px', borderRadius: '999px',
          fontSize: '13px', letterSpacing: '.14em', textTransform: 'uppercase', zIndex: 100,
          opacity: '0', transform: 'translateY(20px)', transition: 'all .4s cubic-bezier(.22,.61,.36,1)',
          boxShadow: '0 20px 40px -15px rgba(0,0,0,.3)'
        });
        document.body.appendChild(toast);
        requestAnimationFrame(function () { toast.style.opacity = '1'; toast.style.transform = 'none'; });
        setTimeout(function () { toast.style.opacity = '0'; toast.style.transform = 'translateY(20px)'; }, 2200);
        setTimeout(function () { toast.remove(); }, 2700);
      });
    });

    // Subtle parallax on hero
    var heroImg = document.querySelector('.eg-hero-image-wrap');
    var heroCard = document.querySelector('.eg-hero-card');
    window.addEventListener('mousemove', function (e) {
      if (!heroImg || window.innerWidth < 960) return;
      var x = (e.clientX / window.innerWidth - .5) * 12;
      var y = (e.clientY / window.innerHeight - .5) * 12;
      heroImg.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      if (heroCard) heroCard.style.transform = 'rotate(-3deg) translate(' + (-x * 1.5) + 'px,' + (-y * 1.5) + 'px)';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
